import { useParams } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ProjectSectionHeader } from '@/components/projects/ProjectSectionHeader'
import { useAuth } from '@/hooks'
import { Permissions } from '@/lib/permissions'

interface WorkflowDefinitionsHeaderProps {
  onCreateDefinition: () => void
}

export function WorkflowDefinitionsHeader({ onCreateDefinition }: WorkflowDefinitionsHeaderProps) {
  const { projectId } = useParams()
  const { hasPermission } = useAuth(projectId)

  return (
    <ProjectSectionHeader sectionName="Definitions">
      {hasPermission(Permissions.Project.Workflow.Create, projectId) && (
        <Button onClick={onCreateDefinition} data-testid="new-workflow-button">
          <Plus className="h-4 w-4" />
          New Definition
        </Button>
      )}
    </ProjectSectionHeader>
  )
}
